var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isImage)?_c('img',{attrs:{"src":_vm.url}}):(_vm.isFont)?_c('span',{class:_vm.cssClass}):_c('span',{staticClass:"icon-placeholder"})}
var staticRenderFns = []

export { render, staticRenderFns }